export enum MatDatepickerLocalesEnum {
  Ar = 'ar',
  En = 'en-GB',
}
